const DEEP_RESEARCH_SKILL_NAMES = new Set(['deep-research', 'research']);
export function isDeepResearchSkillName(skillName) {
    return DEEP_RESEARCH_SKILL_NAMES.has(skillName.trim().toLowerCase());
}
export function hasDeepResearchPrefill(prefills) {
    return !!prefills?.some(({ type, value }) => type === 'skill' && isDeepResearchSkillName(value));
}
//# sourceMappingURL=deepResearchSkill.js.map